import IconChevronDown from '@apollo/icons/default/IconChevronDown.svg';
import IconChevronUp from '@apollo/icons/default/IconChevronUp.svg';
import IconSchema from '@apollo/icons/default/IconSchema.svg';
import IconSingleService from '@apollo/icons/default/IconSingleService.svg';
import { Badge, Button, List, ListItem, ListLabel } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

const SUPERGRAPH_SCHEMA_ID = '@!supergraph!@';

export function SchemasMenu({
  showSupergraphUI,
  hasSuccessfulComposition,
  changedSubgraphs,
  unchangedSubgraphs,
  showUnchangedSubgraphs,
  setShowUnchangedSubgraphs,
}: {
  showSupergraphUI: boolean;
  hasSuccessfulComposition: boolean;
  changedSubgraphs: Array<[string, ...unknown[]]>;
  unchangedSubgraphs: Array<[string, ...unknown[]]>;
  showUnchangedSubgraphs: boolean;
  setShowUnchangedSubgraphs: (value: boolean) => void;
}) {
  return (
    <List isInteractive={true}>
      {showSupergraphUI && (
        <>
          {hasSuccessfulComposition && (
            <>
              <ListLabel>Composed schemas</ListLabel>
              <li>
                {/* ListItem current doesn't work as intended. We have to use the `as` prop to make it the link, and wrap it with `<li/>`. Once ListItem is updated, we will hopefully be able to nest the link inside the listItem instead  */}
                <ListItem
                  as={Link}
                  to={`#${SUPERGRAPH_SCHEMA_ID}`}
                  className="w-full hover:no-underline"
                >
                  <IconSchema className="flex-none" />
                  Supergraph
                </ListItem>
              </li>
            </>
          )}

          {changedSubgraphs.length > 0 && (
            <>
              <ListLabel
                className={classnames(
                  'flex items-center gap-2',
                  hasSuccessfulComposition && 'mt-4',
                )}
              >
                Subgraphs <Badge>{changedSubgraphs.length}</Badge>
              </ListLabel>
              {changedSubgraphs.map(([subgraphName]) => {
                return (
                  <li key={subgraphName}>
                    {/* ListItem current doesn't work as intended. We have to use the `as` prop to make it the link, and wrap it with `<li/>`. Once ListItem is updated, we will hopefully be able to nest the link inside the listItem instead  */}
                    <ListItem
                      as={Link}
                      to={`#${subgraphName}`}
                      className="w-full break-all hover:no-underline"
                    >
                      <IconSingleService className="flex-none" />
                      {subgraphName}
                    </ListItem>
                  </li>
                );
              })}
            </>
          )}
          {unchangedSubgraphs.length > 0 && (
            <>
              <ListLabel className="mt-4">
                <Button
                  variant="buttonLink"
                  className="text-title no-underline"
                  rightIcon={
                    showUnchangedSubgraphs ? (
                      <IconChevronUp />
                    ) : (
                      <IconChevronDown />
                    )
                  }
                  onClick={() =>
                    setShowUnchangedSubgraphs(!showUnchangedSubgraphs)
                  }
                >
                  Unchanged Subgraphs <Badge>{unchangedSubgraphs.length}</Badge>
                </Button>
              </ListLabel>
              {showUnchangedSubgraphs &&
                unchangedSubgraphs.map(([subgraphName]) => {
                  return (
                    <li key={subgraphName}>
                      {/* ListItem current doesn't work as intended. We have to use the `as` prop to make it the link, and wrap it with `<li/>`. Once ListItem is updated, we will hopefully be able to nest the link inside the listItem instead  */}
                      <ListItem
                        as={Link}
                        to={`#${subgraphName}`}
                        className="w-full break-all hover:no-underline"
                      >
                        <IconSingleService className="flex-none" />
                        {subgraphName}
                      </ListItem>
                    </li>
                  );
                })}
            </>
          )}
        </>
      )}
    </List>
  );
}
